import React, {Component} from 'react';

export default class InputError extends Component {
  render () {
    return this.props.visible ? (
      <div className="input-error">
        <span>{this.props.errorMessage}</span>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/InputError.js